import styles from './document-state-badge.module.scss';

const STATE_LABELS: Record<string, string> = {
	Signed: 'Firmado',
	Pending: 'Pendiente',
};

export const DocumentStateBadge = ({ state }: { state: string }) => (
	<span
		className={[
			styles.badge,
			state === 'Signed' ? styles.signed : '',
			state === 'Pending' ? styles.pending : '',
		].join(' ')}
	>
		{STATE_LABELS[state] ?? state}
	</span>
);
